<template>
  <v-tooltip v-if="hint" top>
    <template #activator="{ on, attrs }">

      <v-chip class="font-weight-medium ag-status-chip" small :color="color" :text-color="textColor" v-bind="attrs" v-on="on">
        <v-icon class="mr-1" size="medium">mdi-help-circle-outline</v-icon>
        {{ label }}
      </v-chip>

    </template>

    <template #default>{{ hint }}</template>
  </v-tooltip>
  <v-chip v-else class="font-weight-medium ag-status-chip" small :color="color" :text-color="textColor">
    {{ label }}
  </v-chip>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: String,
  },

  computed: {
    ...mapState("bid", ["statuses"]),
    status() {
      return this.statuses[this.value];
    },
    label() {
      return this.status ? this.status.label : this.value;
    },
    color() {
      return this.status ? this.status.bgColor : "#eeeeee";
    },
    textColor() {
      return this.status ? this.status.textColor : "#000000";
    },
    hint() {
      return this.status?.hint;
    }
  },
};
</script>

<style lang="scss" scoped>
.ag-status-chip.v-chip.v-size--small {
  height: 18px;
}
</style>
